import { Button } from '@mui/material';
import { useEffect, useRef } from 'react';
import { newPortalVersionReload } from 'utils/newPortalVersionReload';

import { useSnackbar } from '@shared/hooks/useSnackbar';
import { useTranslation } from '@shared/i18n';

import { useAppMode } from 'component/root/AppModeProvider';

import { useVersionCheck } from './useVersionCheck';

const APP_UPDATE_SNACKBAR_KEY = 'app-update';

export function useAppUpdateNotice() {
  const { t } = useTranslation();
  const { isSdk } = useAppMode();
  const { enqueueSnackbar } = useSnackbar();
  const { isUpdateAvailable } = useVersionCheck({ enabled: !isSdk });
  const hasNotified = useRef(false);

  useEffect(() => {
    if (!isUpdateAvailable || isSdk || hasNotified.current) {
      return;
    }

    hasNotified.current = true;

    enqueueSnackbar(t('banners.app_update.message'), {
      variant: 'info',
      persist: true,
      key: APP_UPDATE_SNACKBAR_KEY,
      action: (
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={() => void newPortalVersionReload()}
        >
          {t('banners.app_update.reload')}
        </Button>
      ),
    });
  }, [enqueueSnackbar, isSdk, isUpdateAvailable, t]);
}
